import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Container, Card } from "react-bootstrap";
import { ShimmerTable } from "./common/ShimmerTable";
import WhatsAppAPI from "../api/WhatsAppAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import moment from "moment";
import { FaTrash, FaEdit, FaPlus } from "react-icons/fa";

const WabaList = () => {
  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
  const formatDate = (date) => {
    return moment(date).format("DD MMM YYYY");
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await WhatsAppAPI.getWabas();
    // console.log("result",result)
    if (result.success) {
      setBody(result.record);
    } else {
      setBody([]);
      // toast.error("Failed to fetch tags");
    }
    setIsSpinner(true);
  };

  const header = [
    {
      title: "Name",
      prop: "name",
      isFilterable: true,
    },
    {
      title: "Phone",
      prop: "phone",
    },
    {
      title: "Phone Number Id",
      prop: "phone_number_id",
      isFilterable: true,
    },
    {
      title: "WABA Id",
      prop: "waba_id",
    },
    {
      title: "Business Id",
      prop: "business_id",
    },
    {
      title: "Created At",
      prop: "createddate",
      isFilterable: true,
      cell: (row) => formatDate(row.createddate),
    },
  ];

  const labels = {
    beforeSelect: " ",
  };

  return (
    <>
      <Container className="mt-5 mb-5">
        <Row className="mx-5 mb-4">
          <Card className="p-4 header-bg shadow-sm border-0 rounded-3">
            <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
            <small>All Wabas</small>
          </Card>
        </Row>

        <Row className="mx-5 g-0">
          <Col lg={12} className="mb-3">
            <Row className="g-0">
              <Col lg={12}>
                <div className="bg-white shadow-sm border-0 rounded-3 p-4">
                  <h5 className="fw-semibold mb-1">📦 All Wabas</h5>

                  {isSpinner ? (
                    <DatatableWrapper
                      body={body}
                      headers={header}
                      paginationOptionsProps={{
                        initialState: {
                          rowsPerPage: 10,
                          options: [5, 10, 15, 20],
                        },
                      }}
                    >
                      <Row className="mb-3">
                        <Col
                          lg={3}
                          sm={10}
                          xs={10}
                          className="d-flex flex-col justify-content-end align-items-end"
                        >
                          <Filter className="p-2" />
                        </Col>
                        <Col
                          lg={4}
                          sm={2}
                          xs={2}
                          className="d-flex flex-col justify-content-start align-items-start"
                        >
                          <PaginationOptions labels={labels} />
                        </Col>
                      </Row>

                      <div className="table-responsive">
                        <Table
                          striped
                          bordered
                          className="related-list-table"
                          responsive="sm"
                        >
                          <TableHeader />
                          <TableBody />
                        </Table>
                      </div>
                      <Pagination />
                    </DatatableWrapper>
                  ) : (
                    <ShimmerTable row={10} col={4} />
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <ToastContainer />
    </>
  );
};

export default WabaList;
